import React, { useState, useEffect, useRef } from "react";
import Navbarmanager, { infoUtente, loadNav } from "./Navbar";
import { data, useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import Toggle from "../../components/Toggle";
import DatePicker from "../../components/DatePicker";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";
import { Trash2, SquarePen, CardSim, SquareArrowUpRight, Warehouse } from "lucide-react";

const RowPC = ({ data }) => {
    const [isInfoSIMVisible, setIsInfoSIMVisible] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <div className="grid grid-cols-8 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Email}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Indirizzo}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Citta}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Provincia}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Cap}
                </div>
                <div className="flex items-center pl-2" onClick={(e) => { if (data.value.SIM) { setIsInfoSIMVisible(true); e.stopPropagation(); } }}>
                    <CardSim size={22} strokeWidth={2} className={data.value.SIM ? ("text-blue-600 hover:cursor-pointer") : ("text-blue-600 opacity-50")} />
                </div>
                {
                    !data.value.Obsoleta ? (
                        <div className="flex items-center pl-2" onClick={(e) => { e.stopPropagation(); document.cookie = "PreselectAzienda=" + data.value.ID + "; path=/"; navigate('/manager/anagrafica'); }}>
                            <SquareArrowUpRight size={22} strokeWidth={2} className="text-blue-600 hover:cursor-pointer" />
                        </div>
                    ) : (
                        <div></div>
                    )
                }

            </div>
            <PopUp title={"Informazioni SIM"}
                isVisible={isInfoSIMVisible}
                setIsVisible={setIsInfoSIMVisible}
                needConfirm={false}

            >
                <div className="flex flex-col items-center mt-2">
                    <div className="w-[80%] md:w-[70%] mt-1">
                        <p className="flex justify-between">
                            Password :
                            <span className="font-semibold">{data.value.Password}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Scadenza SIM :
                            <span className="font-semibold">{data.value["ScadenzaSIM"]}</span>
                        </p>
                    </div>
                </div>
            </PopUp>
        </>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && header.key !== '' && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Clienti = () => {
    const { isLittle } = useDeviceLayout();
    const headers = [
        { label: 'Nome', key: 'Nome' },
        { label: 'Email', key: 'Email' },
        { label: 'Indirizzo', key: 'Indirizzo' },
        { label: 'Città', key: 'Citta' },
        { label: 'Provincia', key: 'Provincia' },
        { label: 'CAP', key: 'Cap' },
        { label: 'SIM', key: '' },
        { label: 'Articoli', key: '' },
    ];
    const headersImpianti = [
        { label: 'Nome', key: 'Nome' },
        { label: 'Descrizione', key: 'Descrizione' }
    ]
    const [dataTable, setDataTable] = useState([]);
    const [dataAdd, setDataAdd] = useState({
        "Nome": null,
        "Email": null,
        "Indirizzo": null,
        "Citta": null,
        "Provincia": null,
        "Cap": null,
        "SIM": false,
        "Password": null,
        "ScadenzaSIM": null
    });
    const [dataRow, setDataRow] = useState(null);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [isInfoSIMVisible, setIsInfoSIMVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isVisibleArchive, setIsVisibleArchive] = useState(false);
    const toggleRef1 = useRef(null);
    const toggleRef2 = useRef(null);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });
    const [isGestioneImpiantiVisible, setIsGestioneImpiantiVisible] = useState(false);
    const [impianti, setImpianti] = useState([]);
    const [infoImpianti, setInfoImpianti] = useState([]);
    const [dataRowImpianto, setDataRowImpianto] = useState({});
    const [isRowImpiantoVisible, setIsRowImpiantoVisible] = useState(false);
    const [needConfirmImpianto, setNeedConfirmImpianto] = useState(false);
    const [isAddImpiantoVisible, setIsAddImpiantoVisible] = useState(false);
    const [dataAddImpianto, setDataAddImpianto] = useState({
        "Nome": null,
        "Descrizione": null
    });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (isRowInfoVisible && needConfirmRow && toggleRef1.current) {
            console.log(dataRow);
            toggleRef1.current.setValue(dataRow.value.SIM);
        }
    }, [isRowInfoVisible, needConfirmRow]);

    useEffect(() => {
        if (isGestioneImpiantiVisible) {
            setInfoImpianti(impianti.filter(i => i.IDAzienda === dataRow.value.ID && i.ID !== 0).map(item => ({ value: item })));
        }
    }, [isGestioneImpiantiVisible]);

    const onload = async () => {
        //getInfoUtente
        setIsLoading(true);
        try {
            await loadNav();
            //loadDati
            const r1 = await fetch('/getAziende', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd1.map(item => ({ value: item })));
            }

            const r2 = await fetch('/getImpianti', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setImpianti(rd2);
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei dati, riprova più tardi.", onClose: () => { navigate('/manager/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleToggleChange1 = (newValue) => {
        setDataRow({ ...dataRow, value: { ...dataRow.value, SIM: newValue } });
    };

    const handleToggleChange2 = (newValue) => {
        setDataAdd({ ...dataAdd, SIM: newValue });
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaAzienda', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: dataRow.value.value.ID })
                });

                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    setIsLoading(false);
                    window.location.reload(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Operazione fallita, riprova più tardi.", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questo cliente?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModificaCliente = async () => {
        let toggleStatus = toggleRef1.current?.getValue() ?? false;

        if (!dataRow.value.Nome || !dataRow.value.Email || !dataRow.value.Indirizzo || !dataRow.value.Citta || !dataRow.value.Provincia || !dataRow.value.Cap || (toggleStatus && (!dataRow.value.Password || !dataRow.value.ScadenzaSIM))) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/aggiornaAzienda", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    ID: dataRow.value["ID"],
                    Nome: dataRow.value["Nome"],
                    Email: dataRow.value["Email"],
                    SIM: toggleStatus,
                    Password: toggleStatus ? dataRow.value["Password"] : "",
                    ScadenzaSIM: toggleStatus ? dataRow.value["ScadenzaSIM"] : "",
                    Indirizzo: dataRow.value["Indirizzo"],
                    Citta: dataRow.value["Citta"],
                    Provincia: dataRow.value["Provincia"],
                    Cap: dataRow.value["Cap"]
                })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setIsLoading(false);
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica del cliente, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAggiungiCliente = async () => {
        let toggleStatus = toggleRef2.current?.getValue() ?? false;

        if (!dataAdd.Nome || !dataAdd.Email || !dataAdd.Indirizzo || !dataAdd.Citta || !dataAdd.Provincia || !dataAdd.Cap || (toggleStatus && (!dataAdd.Password || !dataAdd.ScadenzaSIM))) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            console.log(dataAdd);
            const response = await fetch("/addAzienda", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    Nome: dataAdd.Nome,
                    Email: dataAdd.Email,
                    SIM: toggleStatus,
                    Password: toggleStatus ? dataAdd.Password : "",
                    ScadenzaSIM: toggleStatus ? dataAdd.ScadenzaSIM : "",
                    Indirizzo: dataAdd.Indirizzo,
                    Citta: dataAdd.Citta,
                    Provincia: dataAdd.Provincia,
                    CAP: dataAdd.Cap
                })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nella creazione del cliente, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }
        setIsLoading(false);
    };

    const confirmPopUpAggiungiImpianto = async () => {
        if (!dataAddImpianto.Nome) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch("/addImpianto", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    IDAzienda: dataRow.value.ID,
                    Nome: dataAddImpianto.Nome,
                    Descrizione: dataAddImpianto.Descrizione
                })
            });
            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nella creazione del sito, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }
        setIsLoading(false);
    };

    const confirmPopUpModificaImpianto = async () => {
        if (!dataRowImpianto.value.Nome) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/aggiornaImpianto", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    ID: dataRowImpianto.value["ID"],
                    Nome: dataRowImpianto.value["Nome"],
                    Descrizione: dataRowImpianto.value["Descrizione"],
                    IDAzienda: dataRowImpianto.value["IDAzienda"]
                })
            });
            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica del sito, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleEliminaImpianto = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaImpianto', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: dataRowImpianto.value.ID })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    window.location.reload(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Operazione fallita, riprova più tardi.", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questo sito?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    return (
        <div className="h-[100svh]">
            <Navbarmanager page={"CLIENTI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["Nome", "Email"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    clickableRow={true}
                    archiveClickableRow={isLittle}
                    actionRow={(row, rowIndex, showArchived) => { setDataRow(row); console.log(row); setIsVisibleArchive(showArchived); setIsRowInfoVisible(true) }}
                    classes="mt-2"
                    needAdd={true}
                    addAction={() => setIsAddVisible(true)}
                    needArchive={true}
                    archiveKey="Obsoleta"
                    archiveValue={true}
                />
                <PopUp title={needConfirmRow ? "Modifica Cliente" : ""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={needConfirmRow}
                    confirmAction={confirmPopUpModificaCliente}
                    cancelAction={() => { setNeedConfirmRow(false); }}
                >
                    {needConfirmRow && (
                        <div className="flex flex-col items-center">
                            <Input
                                label="Nome *"
                                value={dataRow.value.Nome}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Nome: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Email *"
                                value={dataRow.value.Email}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Email: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Indirizzo *"
                                value={dataRow.value.Indirizzo}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Indirizzo: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Città *"
                                value={dataRow.value.Citta}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Citta: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="CAP *"
                                value={dataRow.value.Cap}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Cap: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Provincia *"
                                value={dataRow.value.Provincia}
                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Provincia: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <div className="w-[80%] md:w-[70%] mt-2 flex items-center justify-between">
                                <span>SIM</span>
                                <Toggle ref={toggleRef1} onToggleChange={handleToggleChange1} />
                            </div>
                            {
                                dataRow.value.SIM && (
                                    <>
                                        <DatePicker
                                            label="Scadenza SIM *"
                                            value={dataRow.value.ScadenzaSIM}
                                            setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, ScadenzaSIM: value } })}
                                            error={false}
                                            disabled={false}
                                            classes="w-[80%] md:w-[70%] mt-2"
                                        />
                                        <Input
                                            label="Password SIM *"
                                            value={dataRow.value.Password}
                                            setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Password: value } })}
                                            type="text"
                                            classes="w-[80%] md:w-[70%] mt-2"
                                            disabled={false}
                                            error={false}
                                        />
                                    </>
                                )
                            }
                        </div>
                    )}
                    {!needConfirmRow && (
                        <>
                            {
                                !isVisibleArchive ? (
                                    <>
                                        <div className="grid grid-cols-2 mt-2 gap-2">
                                            <Button type="hollow" onClick={handleElimina}>
                                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => setNeedConfirmRow(true)}>
                                                MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            {
                                                isLittle && (
                                                    <>
                                                        <Button type="hollow" onClick={() => setIsInfoSIMVisible(true)}>
                                                            INFO SIM <CardSim size={16} strokeWidth={2} className="inline-block ml-1" />
                                                        </Button>
                                                        <Button type="hollow" onClick={(e) => { e.stopPropagation(); document.cookie = "PreselectAzienda=" + dataRow.value.ID + "; path=/"; navigate('/manager/anagrafica'); }}>
                                                            ARTICOLI <SquareArrowUpRight size={16} strokeWidth={2} className="inline-block ml-1" />
                                                        </Button>
                                                    </>
                                                )
                                            }
                                        </div>
                                        <div className="flex items-center justify-center mt-2">
                                            <Button type="hollow" classes="w-[70%]" onClick={() => { setIsGestioneImpiantiVisible(true) }}>
                                                GESTISCI SITI <Warehouse size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                    </>

                                ) : isLittle && (
                                    <div className="flex items-center justify-center mt-2">
                                        <Button type="hollow" onClick={() => setIsInfoSIMVisible(true)}>
                                            INFO SIM <CardSim size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                    </div>
                                )}
                        </>
                    )}
                </PopUp>
                <PopUp title={"Informazioni SIM"}
                    isVisible={isInfoSIMVisible}
                    setIsVisible={setIsInfoSIMVisible}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center mt-2">
                        {
                            dataRow && dataRow.value.SIM ? (
                                <div className="w-[80%] md:w-[70%] mt-3">
                                    <p className="flex justify-between">
                                        Password :
                                        <span className="font-semibold">{dataRow.value["Password"]}</span>
                                    </p>
                                    <p className="flex justify-between mt-1">
                                        Scadenza SIM :
                                        <span className="font-semibold">{dataRow.value["ScadenzaSIM"]}</span>
                                    </p>
                                </div>
                            ) : (
                                <>
                                    Il cliente non ha nessuna SIM associata
                                </>
                            )
                        }

                    </div>
                </PopUp>
                <PopUp title={"Aggiungi Cliente"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAggiungiCliente}
                    cancelAction={() => { setIsAddVisible(false); setDataAdd({}) }}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Nome *"
                            value={dataAdd.Nome || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Nome: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Email *"
                            value={dataAdd.Email || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Email: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Indirizzo *"
                            value={dataAdd.Indirizzo || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Indirizzo: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Città *"
                            value={dataAdd.Citta || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Citta: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="CAP *"
                            value={dataAdd.Cap || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Cap: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Provincia *"
                            value={dataAdd.Provincia || ""}
                            setValue={(value) => setDataAdd({ ...dataAdd, Provincia: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <div className="w-[80%] md:w-[70%] mt-2 flex items-center justify-between">
                            <span>SIM</span>
                            <Toggle ref={toggleRef2} onToggleChange={handleToggleChange2} />
                        </div>
                        {
                            dataAdd.SIM && (
                                <>
                                    <DatePicker
                                        label="Scadenza SIM *"
                                        value={dataAdd.ScadenzaSIM || ""}
                                        setValue={(value) => setDataAdd({ ...dataAdd, ScadenzaSIM: value })}
                                        error={false}
                                        disabled={false}
                                        classes="w-[80%] md:w-[70%] mt-2"
                                    />
                                    <Input
                                        label="Password SIM *"
                                        value={dataAdd.Password || ""}
                                        setValue={(value) => setDataAdd({ ...dataAdd, Password: value })}
                                        type="text"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        disabled={false}
                                        error={false}
                                    />
                                </>
                            )
                        }
                    </div>
                </PopUp>
                <PopUp title={`Gestione Siti di ${dataRow?.value?.Nome || ""}`}
                    isVisible={isGestioneImpiantiVisible}
                    setIsVisible={setIsGestioneImpiantiVisible}
                    needConfirm={false}
                >
                    <>
                        <Table
                            headers={headersImpianti}
                            keyForPreview={["Nome", "Descrizione"]}
                            data={infoImpianti}
                            setData={setInfoImpianti}
                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} />}
                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                            forceSmall={true}
                            itemsPC={8}
                            itemsMobile={4}
                            needResearch={true}
                            classes="mt-2"
                            clickableRow={true}
                            actionRow={(row, rowIndex) => { setDataRowImpianto(row); setIsRowImpiantoVisible(true); setNeedConfirmImpianto(false); }}
                            needAdd={true}
                            addAction={() => setIsAddImpiantoVisible(true)}
                            needArchive={true}
                            archiveKey="Obsoleto"
                            archiveValue={true}
                        />
                    </>
                </PopUp>
                <PopUp title={needConfirmImpianto ? "Modifica Sito" : ""}
                    isVisible={isRowImpiantoVisible}
                    setIsVisible={setIsRowImpiantoVisible}
                    needConfirm={needConfirmImpianto}
                    confirmAction={confirmPopUpModificaImpianto}
                    cancelAction={() => { setNeedConfirmImpianto(false); }}
                >
                    {needConfirmImpianto && (
                        <div className="flex flex-col items-center">
                            <Input
                                label="Nome *"
                                value={dataRowImpianto.value.Nome}
                                setValue={(value) => setDataRowImpianto({ ...dataRowImpianto, value: { ...dataRowImpianto.value, Nome: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Descrizione"
                                value={dataRowImpianto.value.Descrizione}
                                setValue={(value) => setDataRowImpianto({ ...dataRowImpianto, value: { ...dataRowImpianto.value, Descrizione: value } })}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                        </div>
                    )}
                    {!needConfirmImpianto && (
                        <div className="grid grid-cols-2 mt-2 gap-2">
                            <Button type="hollow" onClick={handleEliminaImpianto}>
                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                            <Button type="hollow" onClick={() => setNeedConfirmImpianto(true)}>
                                MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>
                    )}
                </PopUp>
                <PopUp title={"Aggiungi Sito"}
                    isVisible={isAddImpiantoVisible}
                    setIsVisible={setIsAddImpiantoVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAggiungiImpianto}
                    cancelAction={() => { setIsAddImpiantoVisible(false); setDataAddImpianto({}) }}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Nome *"
                            value={dataAddImpianto.Nome || ""}
                            setValue={(value) => setDataAddImpianto({ ...dataAddImpianto, Nome: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Descrizione"
                            value={dataAddImpianto.Descrizione || ""}
                            setValue={(value) => setDataAddImpianto({ ...dataAddImpianto, Descrizione: value })}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
            </div>
        </div>
    )
};

export default Clienti;